import { getRemainingTickets } from './pure';

export function filterSarmsForUser(swarms, blacklistedVenues, events, userBuys){
  // BEE-1383
  console.log("DEBUG: filterSarmsForUser parameters: swarms, blacklistedVenues, events, userBuys", swarms, blacklistedVenues, events, userBuys)
  // * filter swarms that the user has not enough remaining tickets for
    let swarmsRT = filterSwarmsByRemainingTickets(swarms,events,userBuys)
    console.log("DEBUG: swarmsRTcd: ", swarmsRT)

  // * filter swarms with event venues where the user is blacklisted
    let swarmsBV = filterSwarmsByUserVenuesBlacklis(swarmsRT, events, blacklistedVenues)
    
  // * filter swarms where event has 1 purchaseLimit and the user already have a buy for
    let swarmsPL = filterSwarmsByPurchaseLimit(swarmsBV, events, userBuys)

  return swarmsPL;

}

export function filterSwarmsByRemainingTickets(swarms,events,userBuys){
  if(userBuys && swarms && events){
    // * calculate remaining tickets for each swarm and filter them
    let newSwarms = swarms.map(swarm => {
      // find event for swarm
      let eventForSwarm = events?.find(event => event?.bteId && swarm?.bteId &&event?.bteId === swarm?.bteId)

      if(!eventForSwarm){
        console.error("DEBUG: No event found for swarm: ", swarm)
        return swarm;
      } 
      return (
        {
          ...swarm, 
          remainingTickets: getRemainingTickets(eventForSwarm, userBuys)
        }
        )
    })

    return newSwarms.filter(swarm => swarm.remainingTickets > 0);
  }else{
    console.error("Missing Data to filter Swarms, parameters Recieved: ", swarms,events,userBuys ,"\n expected swarms,events and userBuys")
  }
}

export function filterSwarmsByUserVenuesBlacklis(swarms, events, blacklistedVenues){
  if(swarms && events && blacklistedVenues){
    // * filter swarms with event venues where the user is blacklisted
    return swarms.filter(swarm => {
      // find event for swarm
      let eventForSwarm = events?.find(event => event?.bteId && swarm?.bteId &&event?.bteId === swarm?.bteId)

      if(!eventForSwarm){
        console.error("DEBUG: No event found for swarm: ", swarm)
        return swarm;
      } 
      console.log("DEBUG: venues: ", blacklistedVenues)
      return !blacklistedVenues.map(v=>parseInt(v.elementValue)).includes(eventForSwarm.venue.id)
    })
  }else{
    console.error("Missing Data to filter Swarms, parameters Recieved: ", swarms,events,blacklistedVenues ,"\n expected swarms,events and blacklistedVenues")
  }
}

export function filterSwarmsByPurchaseLimit(swarms, events, userBuys){
  // in the event is a boolean property runLimit1PurchasePerBuyer that says if the 1 purchase limit is applied for this event

  if(swarms && events && userBuys){

    let onePurchasedRunEvents = []
    
    const runEventsWithLimit = events.filter(e => e.runLimit1PurchasePerBuyer)
    const eventsWithLimit = events.filter(e => e.eventLimit1PurchasePerBuyer)
    
    const purchasedEvents = userBuys.map(buy => buy.eventId)

    runEventsWithLimit.forEach( e => {
      // if the event has runEventIds, check if any of them are in purchasedEvents
        e.runEventIds?.forEach(runEventId => {
          if (purchasedEvents.includes(runEventId)) onePurchasedRunEvents.push(e.bteId);
        });
    });

    eventsWithLimit.forEach( e => {
      if(purchasedEvents.includes(e.bteId)) onePurchasedRunEvents.push(e.bteId);
    })

    // * filter swarms where event has 1 purchaseLimit and the user already have a buy for
    return swarms.filter(swarm => {
      return !(onePurchasedRunEvents.includes(swarm.bteId))
    })
  }else{
    console.error("Missing Data to filter Swarms, parameters Recieved: ", swarms,events,userBuys ,"\n expected swarms,events and userBuys")
  }

}
